module.exports = __webpack_public_path__ + "static/media/special_recognition.2de04cb8.png";